<ds-nav></ds-nav>
<aside class="main-sidebar main-sidebar-custom sidebar-dark-primary elevation-4 ">
  <div class="text-center">
    <a routerLink="/" routerLinkActive="active" class="brand-link">
      <img src="assets/images/logo-s.svg" alt="{{'@metadata.title' | translate}}" class="logo-custom my-2" width="170">
      <img src="assets/images/logo-split.svg" alt="{{'@metadata.title' | translate}}" class="logo-split my-2 ml-2" height="54">
      <div class="d-flex justify-content-end version">{{ version }}</div>
    </a>
  </div>
  <div class="sidebar">
    <!-- Detalhe do usuário -->
    <app-user-detail [name]="userName?.[0]" [avatarImage]="loggedUser?.avatar?.avatarImage"></app-user-detail>
    <nav class="mt-2 mb-5">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item">
          <a class="nav-link" routerLink="/quickAccess" routerLinkActive="active"
            (click)="setTitle(resourceService.getResource('@direction.pages.menu.quickAccess'))">
            <i class="nav-icon fa-solid fa-folder-tree"></i>
            <p>
              {{'@direction.pages.menu.quickAccess' | translate}}
            </p>
          </a>
        </li>
        <li class="nav-item ">
          <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
            (click)="setTitle(resourceService.getResource('@direction.pages.menu.dashboard'))">
            <i class="nav-icon fa-solid fa-chart-line"></i>
            <p>
              {{'@direction.pages.menu.dashboard' | translate }}
            </p>
          </a>
        </li>
        <li class="nav-item" *ngIf="loggedUser?.isAdministrative">
          <a class="nav-link" href="javascript:void(0);" (click)="rebooTurnstilesManager()">
            <i class="nav-icon fa-solid fa-rotate"></i>
            <p>
              {{'@direction.pages.menu.rebooTurnstilesManager' | translate }}
            </p>
          </a>
        </li>
        <li class="nav-item ds-custom-hr">
          <a class="nav-link" href="javascript:void(0);" (click)="showModalUnlockAccess()">
            <i class="nav-icon fa-solid fa-unlock-keyhole"></i>
            <p>
              {{'@direction.pages.menu.unlockAccess' | translate }}
            </p>
          </a>
        </li>
        <!-- menu favorito -->
        <li class="nav-header">
          <div class="d-flex justify-content-between">
            <span>{{'@direction.pages.menu.favorites' | translate }}</span>
          </div>
        </li>
        <li *ngFor="let favorite of menuFavorite" class="nav-item mt-1">
          <a id="{{favorite.title}}" class="nav-link" (click)="navigateTo(favorite.link+'/'+favorite.id, favorite.title)"
            [routerLink]="favorite.link+'/'+favorite.id" *ngIf="favorite.link.indexOf('grid') !== -1" routerLinkActive="active">
            <i *ngIf="favorite.icon.indexOf('ds-icons') === -1" class="nav-icon {{favorite.icon}}"></i>
            <i *ngIf="favorite.icon.indexOf('ds-icons') !== -1" class="nav-icon {{favorite.icon}}">&#xe900;</i>
            <p>
              {{favorite.title}}
            </p>
          </a>
          <a id="{{favorite.title}}" class="nav-link" (click)="navigateTo(favorite.link, favorite.title)" [routerLink]="favorite.link"
            *ngIf="favorite.link.indexOf('grid') === -1" routerLinkActive="active">
            <i *ngIf="favorite.icon.indexOf('ds-icons') === -1" class="nav-icon {{favorite.icon}}"></i>
            <i *ngIf="favorite.icon.indexOf('ds-icons') !== -1" class="nav-icon {{favorite.icon}}">&#xe900;</i>
            <p>
              {{favorite.title}}
            </p>
          </a>
        </li>
        <!-- fim menu favorito -->
      </ul>
      <div class="btn-group ds-custom-fixed-bottom">
        <button type="button" class="btn btn-primary dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false">{{
          getTitleUnitCodeButton(unitCodeSelected) }}
        </button>
        <div class="dropdown-menu ds-custom-dropdown-menu">
          <a class="dropdown-item text-center" href="javascript:void(0);" (click)="setUnitCode(unitCode)"
            *ngFor="let unitCode of unitCodes">{{
            getTitleUnitCodeButton(unitCode) }}</a>
        </div>
      </div>
    </nav>
  </div>
</aside>